// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"ED-z","expressButtonContainerWithPayPal":"FD-z","expressButton":"GD-z","or":"HD-z"};